<template>
  <div class="mainView">
    <div class="header">
      <div class="header-logo"></div>
      <div class="manage-info">
        <el-dropdown>
          <span class="el-dropdown-link" style="color: white">
            {{ userName }}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <template #dropdown>
            <el-dropdown-menu>
              <span>
                <el-dropdown-item>{{ userName }}</el-dropdown-item></span>
              <el-dropdown-item>
                <span @click="exit()">Log out</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
    </div>
    <div class="main-container">
      <div class="title">My Glucose Meters ({{ deviceCount }})
        <el-button class="fr" style="background-color:#88C22E; color: white;width: 140px;"
          @click="handleRefresh">Refresh</el-button>

      </div>
      <div class="form-body">
        <el-form :inline="true" :model="queryForm" style="display:inline-block; float:left;margin-top: 50px;">
          <el-input v-model="searchSN" placeholder="Serial Number" style="width: 180px; margin-right: 0px;"
            @keyup.enter.native="handleSearch">
            <template v-slot:suffix>
              <img class="search-icon" src="../assets/images/icon-search.svg" @click="handleSearch">
            </template>
          </el-input>
          <div class="first-plus">
            <i class="el-icon-plus add-btn fr" @click="handleAdd"></i>
          </div>
          <el-table @cell-click="handleSNClick" class="search-table" :data="filteredDevicelist" :show-header="false"
            :row-style="{ height: '50px' }">
            <el-table-column min-width="100%" type="index" label="" align="center" width="180px">
              <template slot-scope="scope">
                <!-- {{ scope.row }} -->
                <span
                  :style="{ color: calculateCurrentIndex === scope.$index ? '#88C22E' : '', display: 'block', width: '100%' }">{{
                    scope.row }}
                  <i class="el-icon-minus fr" style="font-size: 16px; margin-top: 4px;"
                    @click.stop="handleDelete(scope.row)"></i>
                </span>
              </template>
            </el-table-column>
          </el-table>
        </el-form>
        <div class="gluco-list-container">
          <el-table border size="small" :data="glucoList" style="margin-top: 50px;" :header-cell-style="tableHeaderColor">
            <el-table-column prop="value" align="center" label="Glucose Concentration">
              <template slot-scope="scope">
                {{ scope.row.value + ' mg/dL' }}
              </template>
            </el-table-column>
            <el-table-column prop="measureTime" align="center" label="Time Measured">
            </el-table-column>
          </el-table>
          <Pagination style="float: right" v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        </div>
      </div>
    </div>

    <el-dialog title="Confirm log out" :visible.sync="logOutDialogVisible" width="500px" center :show-close="false">
      <div class="dialog-content">Are you sure you want to log out?</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="logOutDialogVisible = false">Cancel</el-button>
        <el-button type="primary" @click="handleLogOut()">Log out</el-button>
      </span>
    </el-dialog>

    <el-dialog title="Security reminder" :visible.sync="timeoutDialogVisible" width="500px" center
      :close-on-click-modal="false" :show-close="false">
      <p style="width:80%;text-align: center;margin-left: 10%;">Are you still there? <br>
        For your data security, your account
        will be logged out in {{ dialogCount }} {{ dialogCount > 1 ? 'seconds.' : 'second.' }}</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleLogOut()">Log out</el-button>
        <el-button type="primary" @click="handleContinue()">Continue</el-button>
      </span>
    </el-dialog>

    <el-dialog title="Add Meter(s)" :close-on-click-modal="false" :visible.sync="addDialogVisible" width="580px" center
      :show-close="false">

      <div class="meter-dialog-container">
        <div class="ft-16">Account Password</div>
        <el-input class="dialog-input" type="password" v-model="addParam.password"
          placeholder="Enter account password"></el-input>
        <div class="ft-16" style="margin-top: 25px">My Glucose Meters</div>
        <el-input class="dialog-input" v-model="addParam.sns" placeholder="Enter meter serial number"></el-input>
        <div class="meter-dialog-tip ft-16">Please use the "/" following the glucose meter serial number if you'd like to
          key
          into more than one glucose meter.</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleAddCancel">Cancel</el-button>
        <el-button type="primary" @click="handleAddConfirm">Confirm</el-button>
      </span>
    </el-dialog>

    <el-dialog title="Delete Meter" :close-on-click-modal="false" :visible.sync="deleteDialogVisible" width="580px" center
      :show-close="false">

      <div class="meter-dialog-container">
        <div class="delete-dialog-content  ft-16">Serial number for the meter you want to delete is: {{ deleteParam.sn }}</div>
        <div class="ft-16">Account Password</div>
        <el-input class="dialog-input" type="password" v-model="deleteParam.password"
          placeholder="Enter account password"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleDeleteCancel">Cancel</el-button>
        <el-button type="primary" @click="handleDeleteConfirm">Confirm</el-button>
      </span>
    </el-dialog>

    <el-dialog title="Hint" :close-on-click-modal="false" :visible.sync="addHintDialogVisible" width="580px" center
      :show-close="false">

      <div class="meter-dialog-container">
        <div class="delete-dialog-content ft-16">Please confirm the meter's serial number: {{ addParam.sns }}.</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleAddHintCancel">Cancel</el-button>
        <el-button type="primary" @click="handleAddHintConfirm">Confirm</el-button>
      </span>
    </el-dialog>
  </div>
</template>
   
<script>

import Pagination from "../components/Pagination";
import { post } from "@/script/api.js";
import { encrypt } from "@/script/tool.js";

export default {
  components: { Pagination },
  data() {
    return {
      userName: null,
      deviceCount: null,
      devicelist: [],
      glucoList: [],

      idleTimer: null,
      countdownTimer: null,
      dialogCount: 59,
      logOutDialogVisible: false,
      timeoutDialogVisible: false,
      addDialogVisible: false,
      deleteDialogVisible: false,
      addHintDialogVisible: false,

      searchSN: null,
      currentRow: null,
      addParam: {
        password: null,
        sns: null
      },
      deleteParam: {
        sn: null,
        password: null
      },
      queryForm: {
        sn: null,
        pageNo: 1,
        pageSize: 10,
      },
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10,
      },
    };
  },
  mounted() {
    this.userName = localStorage.getItem('email')
    this.startWebCountdown();
    this.getDeviceList();
  },
  beforeDestroy() {
    this.clearAllTimer();
    this.removeEvent();
  },
  computed: {
    filteredDevicelist() {
      if (!this.searchSN) {
        return this.devicelist;
      }
      const keyword = this.searchSN.toLowerCase();
      return this.devicelist.filter(item => item.toLowerCase().includes(keyword));
    },
    calculateCurrentIndex() {
      if (!this.currentRow) {
        return 0;
      }
      if (this.devicelist == []) {
        return 0;
      }
      const keyword = !this.searchSN ? '' : this.searchSN.toLowerCase();
      const filterDevList = this.devicelist.filter(item => item.toLowerCase().includes(keyword));
      console.log('keyword=', keyword, '\ndevList=', filterDevList, '\ncurrentIndex=', filterDevList.indexOf(this.currentRow));
      return filterDevList.indexOf(this.currentRow);
    }
  },
  methods: {
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color:#efefef;color:#333";
      }
    },

    startWebCountdown() {
      this.resetIdleTimer();
      this.addEvent();
    },
    addEvent() {
      window.addEventListener('mousemove', this.resetIdleTimer);
      window.addEventListener('mousedown', this.resetIdleTimer);
    },
    resetIdleTimer() {
      clearTimeout(this.idleTimer);
      this.idleTimer = setTimeout(this.showPopup, 600000);
    },
    showPopup() {
      this.timeoutDialogVisible = true;
      this.startDialogCountdown();
    },

    startDialogCountdown() {
      this.dialogCount = 59;
      this.countdownTimer = setInterval(() => {
        this.dialogCount--;
        if (this.dialogCount <= 0) {
          clearInterval(this.countdownTimer);
          // console.log('一直执行中++++++++++', this.countdownTimer);
          this.handleLogOut();
        }
      }, 1000);
    },
    clearAllTimer() {
      clearTimeout(this.idleTimer);
      clearInterval(this.countdownTimer);
    },
    removeEvent() {
      window.removeEventListener('mousemove', this.resetIdleTimer);
      window.removeEventListener('mousedown', this.resetIdleTimer);
    },
    handleSearch() {
      //实际该方法不用执行任何操作，筛选在计算方法中已经进行了;
      //根据需求可以把计算方法中的计算放置该方法中
      console.log('开始搜索', this.searchSN);
    },
    handleSNClick(row, column, cell, event) {
      // console.log('点击了row=', row, 'column=', column, 'cell=', cell, 'event=', event);
      this.searchSN = ''; //清空搜索框
      if (this.currentRow === row) {
        return;
      }
      this.currentRow = row;
      // this.queryForm.sn = row;
      this.queryForm = {
        sn: row,
        pageNo: 1,
        pageSize: 10,
      },
        this.getGlucoList();
    },
    handleAdd() {
      console.log('点击添加按钮');
      this.addDialogVisible = true;
    },
    handleDelete(row) {
      console.log('点击了删除按钮，row:', row);
      this.deleteDialogVisible = true;
      this.deleteParam.sn = row;
    },
    getDeviceList() {
      post('device/list').then(res => {
        if (res.data && res.data != undefined) {
          this.deviceCount = res.data.length;
          this.devicelist = res.data;
          this.queryForm.sn = res.data[0];
          this.currentRow = res.data[0];
          this.getGlucoList();
        }
      })
    },
    getGlucoList() {
      post('glu/page', this.queryForm).then(res => {
        console.log("数据表", res);
        if (res.data.lists && res.data.lists != undefined) {

          this.glucoList = res.data.lists;
          this.pageparm.currentPage = this.queryForm.pageNo;
          this.pageparm.pageSize = this.queryForm.pageSize;
          this.pageparm.total = res.data.totalCount;
        } else {
          this.glucoList = [];
          this.pageparm.currentPage = this.queryForm.pageNo;
          this.pageparm.pageSize = this.queryForm.pageSize;
          this.pageparm.total = 0;
        }
      })
    },

    //分页插件事件
    callFather(parm) {
      console.log(parm);
      this.queryForm.pageNo = parm.currentPage;
      this.queryForm.pageSize = parm.pageSize;
      this.getGlucoList();
    },

    exit() {
      this.logOutDialogVisible = true;
    },
    handleRefresh() {
      this.searchSN = null;
      this.queryForm = {
        sn: null,
        pageNo: 1,
        pageSize: 10,
      }
      this.getDeviceList();
    },
    handleAddConfirm() {
      if (!this.addParam.password) {
        this.$message.error("Please enter the account password");
        return false;
      }
      if (!this.addParam.sns) {
        this.$message.error("Please enter the meter serial number");
        return false;
      }
      this.addHintDialogVisible = true;
    },
    handleAddCancel() {
      this.clearDialogData();
    },
    handleAddHintCancel() {
      this.addHintDialogVisible = false;
    },
    handleAddHintConfirm() {

      let password = encrypt(this.addParam.password);
      post('device/add', { password, sns: this.addParam.sns }).then(res => {
        console.log("添加请求结果为", res);
        if (res.code == 0) {
          this.$message.success('Successfully added');
          this.clearDialogData();
          this.getDeviceList();
        } else {
          this.addHintDialogVisible = false;
          this.$message.error(res.msg);
        }
      });
    },
    handleDeleteConfirm() {
      if (!this.deleteParam.password) {
        this.$message.error("Please enter the account password");
        return false;
      }
      let password = encrypt(this.deleteParam.password);
      post('device/delete', { password, sn: this.deleteParam.sn }).then(res => {
        console.log("删除请求结果为", res);
        if (res.code == 0) {
          this.$message.success('Successfully deleted');
          this.clearDialogData();
          this.getDeviceList();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleDeleteCancel() {
      this.clearDialogData();
    },
    clearDialogData() {
      this.deleteDialogVisible = false;
      this.deleteParam = {
        sn: null,
        password: null
      };
      this.addDialogVisible = false;
      this.addParam = {
        password: null,
        sns: null
      };
      this.addHintDialogVisible = false;
    },
    handleLogOut() {
      // console.log('登出了');
      // return;
      post('logout').then(res => {
        this.timeoutDialogVisible = false;
        this.logOutDialogVisible = false;
        this.clearAllTimer();
        localStorage.clear();
        this.$router.replace({ path: "/login" });
      }).catch(error => {
        this.timeoutDialogVisible = false;
        this.logOutDialogVisible = false;
        this.clearAllTimer();
        localStorage.clear();
        this.$router.replace({ path: "/login" });
      })
    },
    handleContinue() {
      this.timeoutDialogVisible = false;
      clearInterval(this.countdownTimer);
      this.resetIdleTimer();
    },
  },
};
</script>
  
<style scoped>
/* * {
  font-size: 14px;
  font-weight: 400;
} */

.header {
  background: url("../assets/images/header-bg.png") no-repeat;
  width: 100%;
  height: 60px;
}

.header-logo {
  background: url("../assets/images/header-logo.png") no-repeat;
  width: 173px;
  height: 30px;
  float: left;
  margin-top: 15px;
  margin-left: 20px;
}

.manage-info {
  float: right;
  text-align: right;
  background-size: 100% 100%;
  height: 60px;
}

.el-dropdown-link {
  color: white;
  height: 60px;
  line-height: 60px;
  margin-right: 20px;
}

.main-container {
  margin: 40px 30px auto 30px;
}

.title {
  font-weight: 700;
  font-style: normal;
  font-size: 22px;
  text-align: left;
  height: 40px;
  line-height: 40px;
}

.form-body {
  display: flex;
  justify-content: center;
  width: 100%;
}

.form-body .el-table--scrollable-y ::-webkit-scrollbar {
  display: none;
}

.search-table>>>.el-table__row>td {
  /* 去除表格线 */
  border: none;
}

.search-table>>>.el-table th.is-leaf {
  /* 去除上边框 */
  border: none;
}

div /deep/ .search-table::before {
  background-color: transparent;
}

.search-icon {
  margin-top: 12px;
  margin-right: 3px;
}

.first-plus {
  width: 100%;
  height: 50px;
}

.add-btn {
  color: #88C22E;
  font-size: 16px;
  margin-right: 11px;
  margin-top: 17px;
}

.gluco-list-container {
  min-width: 720px;
  width: 100%
}

.dialog-content {
  width: 100%;
  text-align: center;
  height: 50px;
  line-height: 50px;
}

.meter-dialog-container {
  margin: 0 30px;
}

.dialog-input {
  font-size: 15px;
  margin: 10px 0 0 0;
}

.dialog-input>>>.el-input__inner {
  height: 50px;
  border: 1px solid lightgray;
  width: 100%;
  border-radius: 6px;
  padding-left: 10px;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
}

.meter-dialog-tip {
  margin-top: 10px;
  color: lightgray;
  line-height: 1;
}

.delete-dialog-content {
  margin-bottom: 30px; 
}
</style>
  


// WEBPACK FOOTER //
// src/views/MainView.vue